var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import './style.css';
import { EventChannel } from '@syllepsis/adapter';
import { TOOL_TYPE } from '@syllepsis/editor';
import debounce from 'lodash.debounce';
import React from 'react';
import { CustomButton } from '../../tools';
import { getGroupKey, renderMoreToolButton, renderSylButton } from '../../utils';
var Toolbar = /** @class */ (function (_super) {
    __extends(Toolbar, _super);
    function Toolbar(props) {
        var _this = _super.call(this, props) || this;
        _this.updateFormats = function () {
            var format = _this.props.editor.getFormat();
            if (!format)
                return;
            _this.setState({
                activeFormat: format,
            });
        };
        _this.renderCustomTool = function (content) { return (React.createElement(CustomButton, __assign({ key: "custom-" + content.name }, content, { editor: _this.props.editor }))); };
        _this.renderTool = function (content, depth, extra) {
            if (depth === void 0) { depth = 0; }
            switch (content.type) {
                case TOOL_TYPE.CUSTOM: {
                    return _this.renderCustomTool(content);
                }
                case TOOL_TYPE.MORE: {
                    var groupKey_1 = getGroupKey(content);
                    return renderMoreToolButton({
                        editor: _this.props.editor,
                        content: content,
                        depth: depth,
                        option: _this.props.option,
                        toolbarType: 'static',
                        groupKey: groupKey_1,
                        renderMenu: function (tools, _depth) {
                            return tools.map(function (tool) {
                                return _this.renderTool(tool, _depth + 1, {
                                    groupKey: groupKey_1,
                                    config: content.contentOption,
                                });
                            });
                        },
                    });
                }
                default: {
                    return renderSylButton({
                        editor: _this.props.editor,
                        option: _this.props.option,
                        activeFormat: _this.state.activeFormat,
                        content: content,
                        toolbarType: 'static',
                        depth: depth,
                        extra: extra,
                    });
                }
            }
        };
        _this.state = {
            activeFormat: {},
        };
        _this.autoUpdate = debounce(function () { return _this.updateFormats(); }, 300, {
            leading: true,
        });
        return _this;
    }
    Toolbar.prototype.componentDidMount = function () {
        this.props.editor.on(EventChannel.LocalEvent.ON_CHANGE, this.autoUpdate);
    };
    Toolbar.prototype.componentDidCatch = function (error) {
        this.props.editor.onError(error);
    };
    Toolbar.prototype.render = function () {
        var _this = this;
        var _a = this.props.toolbarLib, contents = _a.contents, editor = _a.editor;
        return (React.createElement("div", { className: "syl-toolbar", onClick: function (e) { return !e.cancelable && editor.focus(); } }, contents.map(function (content) { return _this.renderTool(content); })));
    };
    return Toolbar;
}(React.Component));
export { Toolbar };
//# sourceMappingURL=index.js.map